import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

let push = null;

/** confirmAction({ title, body, entity, confirmLabel, typeToConfirm }) -> Promise<boolean> */
export const confirmAction = (opts) => new Promise((resolve) => (push ? push({ ...opts, resolve }) : resolve(window.confirm(opts.title))));

export function ConfirmHost() {
  const [req, setReq] = useState(null);
  const [typed, setTyped] = useState("");
  useEffect(() => { push = (r) => { setTyped(""); setReq(r); }; return () => { push = null; }; }, []);
  const close = (ok) => { req?.resolve(ok); setReq(null); };
  const need = req?.typeToConfirm ? String(req.typeToConfirm) : null;
  const ready = !need || typed.trim() === need;
  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && close(false)}>
      <DialogContent className="max-w-md" data-testid="confirm-dialog">
        <DialogHeader>
          <div className="mb-1 flex h-10 w-10 items-center justify-center rounded-full bg-risk-tint text-risk"><AlertTriangle size={18} aria-hidden="true" /></div>
          <DialogTitle className="font-display" data-testid="confirm-title">{req?.title}</DialogTitle>
          <DialogDescription className="text-ink-secondary">{req?.body}</DialogDescription>
        </DialogHeader>
        {req?.entity && <p className="rounded-[5px] border border-[#E8C9C5] bg-risk-tint px-3 py-2 text-sm font-medium text-risk" data-testid="confirm-entity">{req.entity}</p>}
        {need && (
          <div className="space-y-1.5">
            <label htmlFor="confirm-type" className="text-sm text-ink-secondary">Type <strong className="font-mono text-ink">{need}</strong> to confirm</label>
            <Input id="confirm-type" value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off" data-testid="confirm-type-input" />
          </div>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => close(false)} data-testid="confirm-cancel">Cancel</Button>
          <Button variant="destructive" disabled={!ready} onClick={() => close(true)} data-testid="confirm-ok">{req?.confirmLabel || "Confirm"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
